import anniversaryImage from '../components/assets/events/42nd-anniversary.jpg';
import mynameImage from '../components/assets/events/myname.png';
import manianImage from '../components/assets/events/manian.jpeg';
import halloweenImage from '../components/assets/events/halloween.jpg';
import nanyuecampImage from '../components/assets/events/nanyuecamp.jpeg';
import winterMusicImage from '../components/assets/events/winter-music.jpeg';

export const homePageCards = [
  {
    imageSrc: anniversaryImage,
    imageAlt: '42nd anniversary event',
    titleKey: 'event-title-15',
    descriptionKey: 'event-description-15',
    link: 'https://mp.weixin.qq.com/s/UeGc0BigdXQSx26_WsZFMA',
  },
  {
    imageSrc: mynameImage,
    imageAlt: 'My Name event',
    titleKey: 'event-title-19',
    descriptionKey: 'event-description-19',
    link: 'https://mp.weixin.qq.com/s/yADRD6lneMyvGJ-gdVCMaA',
  },
  {
    imageSrc: manianImage,
    imageAlt: 'Manian event',
    titleKey: 'event-title-20',
    descriptionKey: 'event-description-20',
    link: 'https://mp.weixin.qq.com/s/4N2yjFGJpLHzgPCDjWZmYA',
  },
  {
    imageSrc: halloweenImage,
    imageAlt: 'Halloween event',
    titleKey: 'event-title-22',
    descriptionKey: 'event-description-22',
    link: 'https://mp.weixin.qq.com/s/ZgSOejRfyPJvIrrG7h6XWw',
  },
  {
    imageSrc: nanyuecampImage,
    imageAlt: 'Nanyue camp event',
    titleKey: 'event-title-18',
    descriptionKey: 'event-description-18',
    link: 'https://mp.weixin.qq.com/s/vSCXgqgBFusRZ2QeA0PoXw',
  },
  {
    imageSrc: winterMusicImage,
    imageAlt: 'Winter music event',
    titleKey: 'event-title-21',
    descriptionKey: 'event-description-21',
    link: 'https://mp.weixin.qq.com/s/pbYfDMGfyFBeAmaparnxbQ',
  },
];
